import get from 'lodash/get'

const fieldsPartial = `
    id
    merchantReference
    merchantName
    mccCode
    name
    categoryCode
    createdOn
    updatedOn
`

const filterTypes = {
  ids: '[ID]',
}

const buildQuery = (fetchType, resourceName, params) => {
  return null
}

const getMutationInputPair = (key, data) => {
  switch (key) {
    case 'id':
    case 'createdOn':
    case 'updatedOn':
    case 'mccCode':
      return null
    default:
      return [key, data[key]]
  }
}

const getParentResource = () => null

const getName = () => 'Merchants'

const getLabel = () => 'Card - Merchants'

const getRecordById = (state, id) => get(state, `admin.resources.Merchants.data.${id}`, null)

const getShowPathForId = id => '/' + getName() + '/' + id + '/show'

const getLabelForRecord = record => {
  if (!record) {
    return ''
  }
  return record.name
}

export default {
  fieldsPartial,
  buildQuery,
  getParentResource,
  getName,
  getLabel,
  getRecordById,
  getShowPathForId,
  getLabelForRecord,
  filterTypes,
  getMutationInputPair,
}
